<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
      
      <!-- <li class="nav-item">
        <sidenav-item
          url="/Slider"
          :class="getRoute() === 'slider' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Slider'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
      <li class="nav-item">
        <sidenav-item
          url="/Followers"
          :class="getRoute() === 'followers' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Womi en chiffres'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/blog"
          :class="getRoute() === 'blog' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Blog'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/recrute"
          :class="getRoute() === 'womi-recrute' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Womi-Recrute'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/Postulation"
          :class="getRoute() === 'postulation' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Recrutés'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/Demande"
          :class="getRoute() === 'demande' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Demande de devis'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/Evenement"
          :class="getRoute() === 'evenement' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Evenement'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/contact"
          :class="getRoute() === 'Contact' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Contactez-nous'"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- <li class="nav-item">
        <sidenav-item
          url="/rtl-page"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="RTL"
        >
          <template v-slot:icon>
            <i class="ni ni-world-2 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
      <li class="nav-item">
        <button type="button" class="btn signout m-4" @click="signOut">Sign out </button>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavItem,
    //SidenavCard
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    signOut(){
      localStorage.removeItem("user_id");
      localStorage.removeItem("token");
      this.$router.push({ path: "/signin" })
    }
  }
};
</script>
<style scoped>
.signout {
  background-color: #A68D5B  ;
  color: white;
}
</style>
